import React from 'react';
import ReactDOM from 'react-dom/client';
import { Buffer } from 'buffer';
import { App } from './App';
import { i18nReady } from './lib/i18n';
import './index.css';

// @react-pdf/layout calls the Node-only `Buffer.isBuffer` unguarded in its
// image pipeline. Each call throws a caught-but-console-spamming
// ReferenceError in the browser, so expose the buffer polyfill globally
// before any PDF code can run.
if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer;
}

// The first paint waits for i18n: Greek readers receive el.json as a split
// chunk, and rendering before it arrives would show an English frame first.
i18nReady.then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
